import { render, staticRenderFns } from "./AddVersion.vue?vue&type=template&id=01907862&scoped=true&"
import script from "./AddVersion.vue?vue&type=script&lang=js&"
export * from "./AddVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01907862",
  null
  
)

export default component.exports